import { Award, Heart, Users, Phone, Shield, Star } from "lucide-react";

const reasons = [
  {
    icon: Award,
    title: "Lignées d'exception",
    description: "Reproducteurs sélectionnés pour leurs pédigrées purs, sans mélange de Neva Masquerade, garantissant les caractéristiques optimales du Sibérien traditionnel.",
  },
  {
    icon: Heart,
    title: "Socialisation naturelle",
    description: "Nos chatons grandissent au sein de notre foyer, habitués aux bruits du quotidien, aux enfants et aux autres animaux pour un tempérament équilibré.",
  },
  {
    icon: Shield,
    title: "Suivi santé rigoureux",
    description: "Tests génétiques et médicaux complets sur nos reproducteurs. Chatons vaccinés, vermifugés et stérilisés avant le départ.",
  },
  {
    icon: Users,
    title: "Accompagnement personnalisé",
    description: "Conseils avant, pendant et après l'adoption. Nous restons disponibles pour répondre à toutes vos questions tout au long de la vie de votre chat.",
  },
  {
    icon: Phone,
    title: "Transparence totale",
    description: "Résultats des tests de santé consultables, visite de l'élevage encouragée, suivi régulier partagé sur nos réseaux sociaux.",
  },
  {
    icon: Star,
    title: "Passion & Professionnalisme",
    description: "Certifiée ACACED, formée par des professionnels expérimentés, et surtout passionnée par cette magnifique race que nous élevons avec amour.",
  },
];

export default function WhyUsSection() {
  return (
    <section
      id="pourquoi"
      data-testid="why-us-section"
      className="relative py-24 lg:py-32 bg-forest overflow-hidden"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-forest-light/20 rounded-full blur-3xl -translate-y-1/2 -translate-x-1/2" />
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-autumn/10 rounded-full blur-3xl translate-y-1/2 translate-x-1/2" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section header */}
        <div className="section-animate text-center mb-16">
          <span className="font-accent text-autumn text-xl">Notre engagement</span>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold text-white mt-2 mb-6">
            Pourquoi Nous Choisir ?
          </h2>
          <p className="font-body text-lg text-cream/80 max-w-2xl mx-auto">
            Adopter chez La Taïga Siberia, c'est choisir un élevage familial
            qui place le bien-être des chats et la satisfaction des adoptants au cœur de tout.
          </p>
        </div>

        {/* Reasons grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <div
              key={reason.title}
              className="section-animate bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-12 h-12 bg-autumn/20 rounded-xl flex items-center justify-center mb-4">
                <reason.icon className="w-6 h-6 text-autumn" />
              </div>
              <h3 className="font-heading text-xl font-semibold text-white mb-3">
                {reason.title}
              </h3>
              <p className="font-body text-sm text-cream/70 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        {/* Quote */}
        <div className="section-animate mt-16 text-center">
          <blockquote className="max-w-3xl mx-auto">
            <p className="font-accent text-2xl sm:text-3xl text-sand italic">
              "Notre objectif n'est pas de produire le plus de chatons possible, 
              mais de partager des compagnons d'exception avec des familles aimantes."
            </p>
            <cite className="font-body text-sm text-cream/60 mt-4 block">
              — L'équipe La Taïga Siberia
            </cite>
          </blockquote>
        </div>
      </div>
    </section>
  );
}
